import React from 'react'
import injectSheet from 'react-jss'
import Typography from '@mui/material/Typography'
import { Box } from '@mui/material'

const styles = {
    header: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        justifyContent: 'space-between',
        alignItems: 'center',
        alignContent: 'center',
        minHeight: '37px',
    }
}

const Header = ({
    children,
    classes,
    title,
    sx = {}
}) => (
    <Box className={classes.header}>
        <Typography variant='h1' sx={{
            fontSize: '20px',
            fontFamily: '"Roboto Bold", Helvetica, sans-serif',
            color: 'rgba(0, 0, 0, 0.87)',
            ...sx
        }}>
            {title || ' '}
        </Typography>
        {children}
    </Box>
)

export default injectSheet(styles)(Header)
